import React from 'react';
import { motion } from 'framer-motion';
import { trackCTAClick } from '../utils/metaPixel';
export function HeroSection() {
  const checkoutUrl = 'https://www.yenniwellness.com/cart/44544369688711:1';
  return <section className="relative bg-warm-white overflow-hidden" data-id="element-131">
      {/* ===== MOBILE HERO ===== */}
      <div className="md:hidden px-5 pt-6 pb-8" data-id="element-132">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center text-center" data-id="element-133">
          {/* Micro-label */}
          <p className="text-warm-accent font-semibold tracking-[0.2em] text-[9px] uppercase mb-5" data-id="element-134">
            CORTISOL • ESTRÉS • HORMONAS • INSOMNIO
          </p>

          {/* Main headline — large and dominant */}
          <h1 className="text-[clamp(32px,10vw,48px)] font-heading font-bold text-olive leading-[1.05] mb-4" data-id="element-135">
            Nunca más 3AM
          </h1>

          {/* Short emotional subheadline */}
          <p className="text-[13px] text-warm-gray leading-relaxed max-w-[300px] mb-6" data-id="element-136">
            Descubre por qué tu cuerpo te despierta en la madrugada después de
            los 40… y cómo volver a dormir profundamente.
          </p>

          {/* Ebook image */}
          <div className="mb-6" data-id="element-137">
            <img src="https://cdn.magicpatterns.com/uploads/6EtJxy2EX7XjewdxLZ9em1/mockupYW.png" alt="Nunca Más 3AM — Protocolo de 7 días para volver a dormir profundo" className="w-[180px] h-auto object-contain drop-shadow-2xl" data-id="element-138" />
          </div>

          {/* Pricing Block */}
          <div className="bg-cream border-2 border-sage rounded-2xl p-4 w-full max-w-sm shadow-soft relative" data-id="element-139">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-sage text-white text-[9px] font-bold px-3 py-0.5 rounded-full whitespace-nowrap" data-id="element-140">
              👇 PRECIO DE LANZAMIENTO
            </div>

            <div className="flex items-center justify-center gap-2 text-warm-gray text-[10px] mt-1" data-id="element-141">
              <span className="line-through decoration-warm-accent/50" data-id="element-142">
                $27.00 USD
              </span>
              <span className="bg-warm-accent text-white text-[9px] font-bold px-2 py-0.5 rounded-full" data-id="element-143">
                -63% OFF
              </span>
            </div>

            <div className="text-4xl font-bold text-olive font-heading py-1" data-id="element-144">
              $9.99 <span className="text-lg" data-id="element-145">USD</span>
            </div>

            <p className="text-sage font-medium text-[10px] mb-3" data-id="element-146">
              Solo por 3 días · Oferta de lanzamiento
            </p>

            <a href={checkoutUrl} onClick={trackCTAClick} className="block w-full bg-[#E8763A] hover:bg-[#D4682F] text-white font-extrabold py-3.5 px-6 rounded-full transition-all transform hover:scale-[1.02] shadow-lg text-[13px] text-center uppercase tracking-wide" data-id="element-147">
              SÍ, QUIERO VOLVER A DORMIR TRANQUILA
            </a>

            <p className="text-warm-gray text-[9px] mt-2 font-medium" data-id="element-148">
              Pago único • Descarga inmediata • Garantía 7 días
            </p>
            <p className="text-warm-gray/70 text-[9px] mt-0.5 leading-snug" data-id="element-149">
              🔒 Pago Seguro 100%. Soporte 24/7 vía{' '}
              <a href="https://wa.me/16468066813?text=Hola%20Yenny,%20tengo%20una%20duda%20con%20El%20Interruptor%20del%20Sueño." target="_blank" rel="noopener noreferrer" className="text-[#25D366] font-semibold underline hover:text-[#1EBE5A]" data-id="element-150">
                WhatsApp
              </a>
            </p>
          </div>
        </motion.div>
      </div>

      {/* ===== DESKTOP HERO ===== */}
      <div className="hidden md:block py-20 lg:py-24 px-4" data-id="element-151">
        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-152">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="flex flex-col space-y-5" data-id="element-153">
            {/* Emotional micro-label */}
            <p className="text-warm-accent font-medium tracking-wide text-sm uppercase" data-id="element-154">
              Cortisol · Estrés acumulado · Inflamación · Hormonas · Agotamiento
              femenino
            </p>

            {/* Headline */}
            <h1 className="text-4xl lg:text-5xl xl:text-6xl font-heading font-bold text-olive leading-tight" data-id="element-155">
              Nunca más 3AM: descubre por qué tu cuerpo te despierta en la
              madrugada después de los 40
            </h1>

            {/* Subheadline */}
            <p className="text-xl text-warm-gray leading-relaxed max-w-xl" data-id="element-156">
              Si te duermes cansada pero despiertas entre las 2AM y 4AM con
              ansiedad, mente acelerada o sensación de agotamiento, este
              protocolo natural te ayudará a calmar tu sistema nervioso, reducir
              el cortisol nocturno y volver a dormir profundamente sin depender
              de pastillas.
            </p>

            {/* Pricing Block */}
            <div className="bg-cream border-2 border-sage rounded-2xl p-8 text-center max-w-md shadow-soft relative" data-id="element-157">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-sage text-white text-xs font-bold px-3 py-0.5 rounded-full whitespace-nowrap" data-id="element-158">
                👇 PRECIO DE LANZAMIENTO
              </div>

              <div className="flex items-center justify-center gap-2 text-warm-gray text-sm mt-1" data-id="element-159">
                <span className="line-through decoration-warm-accent/50" data-id="element-160">
                  $27.00 USD
                </span>
                <span className="bg-warm-accent text-white text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-161">
                  -63% OFF
                </span>
              </div>

              <div className="text-6xl font-bold text-olive font-heading py-0.5" data-id="element-162">
                $9.99 <span className="text-3xl" data-id="element-163">USD</span>
              </div>

              <p className="text-sage font-medium text-sm" data-id="element-164">
                Solo por 3 días · Oferta de lanzamiento
              </p>

              <a href={checkoutUrl} onClick={trackCTAClick} className="block w-full mt-4 bg-[#E8763A] hover:bg-[#D4682F] text-white font-extrabold py-4 px-6 rounded-full transition-all transform hover:scale-[1.02] shadow-lg text-lg text-center uppercase tracking-wide" data-id="element-165">
                SÍ, QUIERO VOLVER A DORMIR TRANQUILA
              </a>

              <p className="text-warm-gray text-xs mt-1.5 font-medium" data-id="element-166">
                Pago único • Descarga inmediata • Garantía 7 días
              </p>
              <p className="text-warm-gray/70 text-[11px] mt-0.5 leading-snug" data-id="element-167">
                🔒 Pago Seguro 100%. Soporte 24/7 disponible vía{' '}
                <a href="https://wa.me/16468066813?text=Hola%20Yenny,%20tengo%20una%20duda%20con%20El%20Interruptor%20del%20Sueño." target="_blank" rel="noopener noreferrer" className="text-[#25D366] font-semibold underline hover:text-[#1EBE5A]" data-id="element-168">
                  WhatsApp
                </a>
              </p>
            </div>
          </motion.div>

          {/* Image Content — desktop only */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative flex justify-center lg:justify-end" data-id="element-169">
            <div className="relative w-full max-w-lg" data-id="element-170">
              <div className="absolute inset-0 bg-sage/10 rounded-full blur-3xl transform scale-110 -z-10" data-id="element-171"></div>
              <img src="https://cdn.magicpatterns.com/uploads/6EtJxy2EX7XjewdxLZ9em1/mockupYW.png" alt="Nunca Más 3AM — Protocolo de 7 días para volver a dormir profundo" className="w-full h-auto object-contain drop-shadow-2xl" data-id="element-172" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}